var map = {
	"./MinimisedEvent": [
		1046,
		9,
		621
	],
	"./MinimisedEvent.js": [
		1046,
		9,
		621
	],
	"./MinimisedEvent.scss": [
		1670,
		7,
		1086
	],
	"./MinimisedResearch": [
		1047,
		9,
		622
	],
	"./MinimisedResearch.js": [
		1047,
		9,
		622
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1397;
module.exports = webpackAsyncContext;